import { useEffect } from 'react';
export function useTermsModalAgreedResetOnOpen(isOpen, setAgreed) {
    useEffect(() => {
        if (isOpen) {
            setAgreed(false);
        }
    }, [isOpen, setAgreed]);
}
